const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDishes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.2,
    height: 67.97,
    viewBox: "0 0 48.2 67.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 10.37,
    width: 47,
    height: 57,
    rx: 0.8,
    ry: 0.8,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 17.37,
    width: 32,
    height: 24,
    rx: 2.4,
    ry: 2.4,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 45.37,
    width: 6,
    height: 6,
    rx: 0.79,
    ry: 0.79,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 56.37,
    width: 6,
    height: 6,
    rx: 0.79,
    ry: 0.79,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.4,10.37L41.54.62c.54-.13,1.06.28,1.06.84v8.91",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 32.37,
    width: 23,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.49,24.37h.84c3.81,0,6.89,3.09,6.89,6.89v1.11h-14.62v-1.11c0-3.81,3.09-6.89,6.89-6.89Z",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.1,
    cy: 22.87,
    r: 0.5,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.6,
    y1: 45.37,
    x2: 25.6,
    y2: 45.37,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.6,
    y1: 51.37,
    x2: 19.1,
    y2: 51.37,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.6,
    y1: 56.37,
    x2: 25.6,
    y2: 56.37,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.6,
    y1: 61.37,
    x2: 19.1,
    y2: 61.37,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishes);
export default __webpack_public_path__ + "static/media/dishes.daebea7ee67b7d9bd9731176b4dd1489.svg";
export { ForwardRef as ReactComponent };